module.exports = __webpack_public_path__ + "static/media/star.f3e4577e.svg";